import Icon, { IconType } from 'components/Icon';
import * as S from './styles';

interface NavTabProps {
	icon?: IconType;
	label: string;
	active?: boolean;
	onClick?: () => void;
	onDoubleClick?: () => void;
}

const NavTab = ({ icon, label, active, onClick, onDoubleClick }: NavTabProps) => {
	return (
		<S.Base active={active} onClick={onClick} onDoubleClick={onDoubleClick}>
			{icon && <Icon type={icon} width={16} height={16} />}
			{label}
		</S.Base>
	);
};

export default NavTab;
